const LOCAL_STORAGE_KEYS = {
    USER_INFO: 'user-info',
}

export { LOCAL_STORAGE_KEYS }